



































































import Vue from 'vue';
import MobileDetect from 'mobile-detect';
import { MyDreams, Dream } from 'sparkello-core';
import { DreamWebDAO } from '@/web';
import DreamListItem from '@/vue-components/dreams/DreamListItem.vue';
import DreamListOptionsModal, { DreamListOptionsModalInterface } from '@/vue-components/dreams/DreamListOptionsModal.vue';
import Draggable from 'vuedraggable';
import ThreeDots from '@/assets/img/icons/three-dots.svg';

interface DreamListData {
  title: string;
  drag: boolean;
  editMode: boolean;
}

const md = new MobileDetect(window.navigator.userAgent);

export default Vue.extend({
  name: 'DreamList',
  data(): DreamListData {
    return {
      title: 'Sparkello - Dreams',
      drag: false,
      editMode: false,
    } as DreamListData;
  },
  components: {
    DreamListItem,
    DreamListOptionsModal,
    Draggable,
    ThreeDots,
  },
  computed: {
    myDreams(): MyDreams {
      return this.$store.state.myDreams;
    },
    orderedDreamList: {
      get(): Dream[] {
        return this.$store.state.myDreams.orderedList;
      },
      set(value: Dream[]): void {
        console.log('New order array', value);
        DreamWebDAO.getInstance().setDreamOrder(value);
      },
    },

  },
  created() {
    DreamWebDAO.getInstance().subscribeToMyDreamsListChanges();
  },
  methods: {
    dragOptions() {
      //Parameters to pass to the Draggable component
      const disabled = !(this?.editMode || false);
      return {
        animation: 200,
        group: 'description',
        disabled,
        ghostClass: 'ghost',
        delay: 0,
      };
    },
    showOptionsModal(): void {
      console.log('showOptionsModal');
      (this.$refs.optionsModal as DreamListOptionsModalInterface).show();
    },
    isTouchScreen(): boolean {
      return md.mobile() != null;
    },
  },
});
